import { Card, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DraggableList from "../../../common/DraggableList";
import {
  getAllRoles,
  permissionUpdate,
} from "../../../actionCreator/roleManagementActionCreator";
import { useAlert } from "../../../context/AlertProvider";
import { userRoles } from "../../../config";

const RoleHierarchy = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const roles = useSelector((state) => state.roleManagementReducer.roles);
  const loading = useSelector((state) => state.roleManagementReducer.loading);
  const [roleData, setRoles] = useState([]);

  useEffect(() => {
    if (roles?.roles) {
      setRoles(roles.roles);
    }
  }, [roles]);

  const handleUpdate = async (payload) => {
    if (loading) return;
    const res = await dispatch(permissionUpdate(payload));
    dispatch(getAllRoles());
    if (res.status !== 200) {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  const renderRoleCard = (role, index) => {
    const totalPermissionCount = Object.values(role?.permissions).reduce(
      (sum, moduleArray) => sum + moduleArray.length,
      0,
    );

    return (
      <Tooltip
        title={
          !index
            ? "Admin role cannot be reordered due to highest privilege."
            : null
        }
      >
        <div
          style={{
            padding: "10px 20px",
            border: "1px solid #ccc",
            borderRadius: 6,
            background: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "move",
            marginBottom: 12,
          }}
        >
          <div className="d-flex flex-column">
            <span className="fw-semibold tw-text-sm text-capitalize">
              {role?.name}
            </span>
            <span className="heading12px text-color-6E6E6E">
              {!!index ? `Priority level: ${index + 1}` : "Highest priority"}
            </span>
          </div>
          <div className="rounded-pill heading12px bg-muted p5px px-10">
            {totalPermissionCount} permissions
          </div>
        </div>
      </Tooltip>
    );
  };

  return (
    <Card
      title={<div className="tw-text-sm">Visual Role Hierarchy</div>}
      className="rounded-2xl shadow-md mt20"
    >
      <p className="text-color-6E6E6E fw-medium">
        Drag and drop roles to reorder them. Higher positions have greater
        permissions precedence.
      </p>
      <p className="text-color-6E6E6E heading12px fw-normal mb20">
        Higher roles in the hierarchy can override lower roles.
      </p>
      <div className="d-flex flex-column">
        <DraggableList
          items={roleData}
          onChange={(val) => {
            setRoles(val);
            handleUpdate({
              roles: val?.filter((d) => d?.name !== userRoles?.admin),
            });
          }}
          renderItem={renderRoleCard}
        />
      </div>
    </Card>
  );
};

export default RoleHierarchy;
